<div
  class="h-[calc(100vh-(6.5rem))] w-full flex flex-col px-4 xl:px-8 gap-4 relative"
>
  <app-top-banner
    title="Subscription and Billing"
    [hideAdd]="true"
    [viewDetails]="false"
  >
  </app-top-banner>
  <div class="flex-1 w-full flex flex-col relative">
    <div class="flex-1 flex flex-col rounded-lg overflow-hidden">
      <div 
      animate.enter="animate-right"
      class="w-full flex gap-4 relative">
        <div class="relative grid grid-cols-4 w-fit">
          <div class="absolute z-0 grid grid-cols-4 w-full h-full">
            <div
              class="!h-[90%] bg-primary-600 transition-all duration-300 ease-in-out rounded-2xl my-[2px] border border-gray-200"
              [ngClass]="{
                'translate-x-0': routeOn == routes[1].path,
                'translate-x-[100%] ': routeOn == routes[2].path,
                'translate-x-[200%] ': routeOn == routes[3].path,
                'translate-x-[300%] ': routeOn == routes[4].path
              }"
            ></div>
          </div>
          @for (tab of routes.slice(1); track $index) {

          <!--  -->
          <button
            (click)="routeOn = tab.path"
            [routerLink]="[tab.path]"
            [routerLinkActive]="'text-white'"
            class="px-4 py-2 z-10 text-sm flex items-center justify-center gap-2 rounded-full capitalize transition duration-300 ease-in-out"
          >
            @if(tab.data['iconType']=='SVG'){
            <mat-icon [svgIcon]="tab.data['icon']"></mat-icon>
            } @else{
            <mat-icon>{{ tab.data["icon"] }} </mat-icon>
            }
            {{ tab.data["label"] }}
          </button>
          }
        </div>
      </div>
      <div class="rounded-md flex-1 flex flex-col">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
